// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"FreeMembershipBadge_badgeWrapper__Mml05"};